import { render, staticRenderFns } from "./ViewTransactionsCxP.vue?vue&type=template&id=134684f2&scoped=true"
import script from "./ViewTransactionsCxP.vue?vue&type=script&lang=js"
export * from "./ViewTransactionsCxP.vue?vue&type=script&lang=js"
import style0 from "./ViewTransactionsCxP.vue?vue&type=style&index=0&id=134684f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134684f2",
  null
  
)

export default component.exports